export {default} from "./firstSlide";
